import asyncComponent from './components/core/asyncComponent';

import { BASE_REPORTS_URL } from '../common/utilities/routes-util';

// const Blank = asyncComponent(() => import(/* webpackChunkName: "home" */ './containers/Blank'));
const Home = asyncComponent(() => import(/* webpackChunkName: "home" */ './containers/Home'));
const Onboarding = asyncComponent(() => import(/* webpackChunkName: "onboarding" */ './containers/Onboarding'));
const Inbox = asyncComponent(() => import(/* webpackChunkName: "onboarding" */ './containers/Inbox'));

const MomentDetail = asyncComponent(() => import(/* webpackChunkName: "momentDetail" */ './containers/MomentDetail'));
const SimulationDetail = asyncComponent(() => import(/* webpackChunkName: "simulationDetail" */ './containers/SimulationDetail'));
const SimulationDebrief = asyncComponent(() => import(/* webpackChunkName: "simulationDebrief" */ './containers/SimulationDebrief'));
const SimulationRunner = asyncComponent(() => import(/* webpackChunkName: "simulationRunner" */ './containers/SimulationRunner'));
const InvitationLanding = asyncComponent(() => import(/* webpackChunkName: "invitationLanding" */ './containers/InvitationLanding'));
const Trainee = asyncComponent(() => import(/* webpackChunkName: "Trainee" */ './containers/Trainee'));
const Trainer = asyncComponent(() => import(/* webpackChunkName: "Trainer" */ './containers/Trainer'));
const Coach = asyncComponent(() => import(/* webpackChunkName: "Coach" */ './containers/Coach'));
const CertifyLanding = asyncComponent(() => import(/* webpackChunkName: "CertifyLanding" */ './containers/CertifyLanding'));
const MomentPreview = asyncComponent(() => import(/* webpackChunkName: "momentPreview" */ './containers/MomentPreview'));
const ScreenPreview = asyncComponent(() => import(/* webpackChunkName: "ScreenPreview" */ './containers/ScreenPreview'));
const Path = asyncComponent(() => import(/* webpackChunkName: "Path" */ './containers/Path/Path'));
const Reports = asyncComponent(() => import(/* webpackChunkName: "Reports" */ './containers/Reports/Reports'));
const Profile = asyncComponent(() => import(/* webpackChunkName: "Profile" */ './containers/Profile/Profile'));
const AIConversation = asyncComponent(() => import(/* webpackChunkName: "AIConversation" */ './containers/AIConversation/index'));
const AIConversationPreview = asyncComponent(() => import(/* webpackChunkName: "AIConversation" */ './containers/AIConversationPreview/index'));

export default [
  {
    path: 'onboarding',
    component: Onboarding,
  },
  {
    path: 'inbox',
    component: Inbox,
  },
  {
    path: 'invitations/:invitationId',
    component: InvitationLanding,
  },
  {
    path: 'moments/:momentId/preview',
    component: MomentPreview,
  },
  {
    path: 'screens/:screenId/preview',
    component: ScreenPreview,
  },
  {
    path: 'moments/:momentId',
    component: MomentDetail,
  },
  {
    path: 'simulations/:simulationId/activity/:activityId',
    component: SimulationRunner,
  },
  {
    path: 'ai-conversation/:contentAreaId/attempt/:attemptId',
    component: SimulationDebrief,
  },
  {
    path: 'ai-conversation/:contentAreaId/preview',
    component: AIConversationPreview,
  },
  {
    path: 'simulations/:simulationId',
    component: SimulationDetail,
  },
  {
    path: 'coach/:userId',
    component: Coach,
  },
  {
    path: 'coach',
    component: Coach,
  },
  {
    path: 'certify/start',
    component: Trainee,
  },
  {
    path: 'certify',
    component: CertifyLanding,
  },
  {
    path: 'certification/trainee/:traineeId',
    component: Trainer,
  },
  {
    path: 'path',
    component: Path,
  },
  {
    path: BASE_REPORTS_URL,
    component: Reports,
  },
  {
    path: 'profile',
    component: Profile,
  },
  {
    path: 'ai-conversation/:contentAreaId',
    component: AIConversation,
  },
  {
    path: 'force-error',
    component: () => {
      throw new Error('This is a forced error');
    },
  },
  {
    path: '',
    component: Home,
  },
];
